<!-- 最上方的顶部icon -->
<template>
  <div class="bar">
    <div class="left">
      <Image src="logo1"/>
      <div class="title">
        <h3 class="title-name">{{ title }}</h3>
        <span class="desc">{{ desc }}</span>
      </div>
    </div>
    <div class="right">
      <!-- 手游的时候有这些 -->
      <template v-if="computedTeam == 'txm'">
        <button
          class="header-go"
          @click="handleGo"
          v-click="{ btn_name: 'guanwnag' }"
        >
          {{ showText ? '前往官网' : '' }}
        </button>
        <button
          class="header-download"
          @click="handleDownLoad"
          v-click="{ btn_name: 'download' }"
        >
          {{ showText ? '下载游戏' : '' }}
        </button>
      </template>
      <template v-else-if="computedTeam == 'tx2'">
        <TxButton src="top_home" name="tx2 官方网站"></TxButton>
      </template>
      <template v-else>
        <button
          class="header-go"
          @click="handleGo"
          v-click="{ btn_name: 'guanwnag' }"
        >
          {{ showText ? '前往官网' : '' }}
        </button>
      </template>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'mobile',
  },
  name: {
    type: String,
    default: 'ios',
  },
  title: {
    type: String,
    default: '天下贰经典版',
  },
  desc: {
    type: String,
    default: '携手启程 地老天荒',
  },
  logo: {
    type: String,
    default: 'txm_logo',
  },
  showText: {
    type: Boolean,
    default: false,
  },
});
import { computed } from 'vue';

const isIOS = computed(() => {
  if (props.name.includes('iOS')) {
    return true;
  } else {
    return false;
  }
});

const computedLogoGo = computed(() => {
  if (import.meta.env.VITE_TEAM == 'tx3') {
    return 'https://tx3.163.com/m/';
  } else if (import.meta.env.VITE_TEAM == 'tx2') {
    return 'https://tx2.163.com/m/';
  } else {
    return 'https://tx.163.com/m/';
  }
});

function handleGo() {
  window.location.href = computedLogoGo.value;
}

const computedTeam = computed(() => {
  if (import.meta.env.VITE_TEAM == 'txm') {
    return 'txm';
  } else if (import.meta.env.VITE_TEAM == 'tx2') {
    return 'tx2';
  } else {
    return 'tx3';
  }
});

function handleDownLoad() {
  let href = '';
  if (isIOS.value) {
    href =
      'https://apps.apple.com/cn/app/%E5%A4%A9%E4%B8%8B-%E7%83%BD%E7%81%AB%E5%B7%B4%E8%9C%80/id1086981081';
  } else {
    href = 'https://adl.netease.com/d/g/tx/c/fab';
  }
  window.location.href = href;
}

function handleDownLoadTx2() {
  window.location.href = 'https://tx2.163.com/download/index.html';
}

function handleRegister() {
  let href = '';
  if (import.meta.env.VITE_TEAM == 'tx2') {
    href = 'https://tx3.163.com/reg/';
  } else {
    href = 'https://tx3.163.com/reg/';
  }
  window.location.href = href;
}
</script>
<style scoped lang="scss">
.bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 150;
  @include bg('shang');
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.left {
  display: flex;
  flex-direction: row;
}

.title {
  display: flex;
  flex-direction: column;
  padding: 20px 0px;
  margin-left: 20px;
}

.desc {
  font-size: 20px;
  margin-top: -5px;
  color: #e2c88f94;
}

.title-name {
  font-size: 32px;
  color: #e2c88f;
}

.right {
  width: 320px;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
</style>
